import lapdev from '../../lapdev';

export function updateUserInfo(data) {
  return lapdev.put('users/me', data);
}
